var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSortingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33335 12.8333L11.6667 10.5L9.91669 10.5L9.91669 1.75L8.75002 1.75L8.75002 10.5L7.00002 10.5L9.33335 12.8333Z",
    fill: "#3A3A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 1.1665L2.33333 3.49984L4.08333 3.49984L4.08333 12.2498L5.25 12.2498L5.25 3.49984L7 3.49984L4.66667 1.1665Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortingArrow);
export default __webpack_public_path__ + "static/media/ic-sorting-arrow.3371ca2d0bea35fdee42929505af9be5.svg";
export { ForwardRef as ReactComponent };